import { useBloomreach } from "~/composables";
import { useGlobalLabelsStore } from "~/stores/global-labels-store";

// Helper to access global labels safely
const getGlobalLabels = () => {
  const globalLabelsStore = useGlobalLabelsStore();
  return globalLabelsStore.getStoredLabels || {};
};

export const getCMSItem = (k) => {
  const globalLabels = getGlobalLabels();
  return globalLabels[k] || "";
};

export const getCMSLabels = (k) => {
  const globalLabels = getGlobalLabels();
  return k === "delivery-and-returns"
    ? globalLabels[k]?.description?.value || ""
    : globalLabels[k]?.dname || "";
};

export const getCMSFlag = (k) => {
  const globalLabels = getGlobalLabels();
  return globalLabels[k]?.flag?.selectionValues?.[0]?.key?.toLowerCase() || "";
};

export const checkCMSFlag = (k, value) => {
  return getCMSFlag(k) === value;
};

export const showingOfProductsTitle = (resultsShowing, totalCount) => {
  const title = getCMSLabels("showing-0-of-1-products");
  const updatedTitle = title.replace("{0}", resultsShowing);
  return updatedTitle.replace("{1}", totalCount);
};

export const getUserLoginLabels = (k) => {
  const { userLoginLabels } = useBloomreach();
  return userLoginLabels?.value ||''
};

export const getUserRegisterLabels = (k) => {
  const { userRegisterLabels } = useBloomreach();
  return userRegisterLabels?.value || {};
};
